import React from 'react';
import Slider, { Settings } from 'react-slick';
import styles from './Carousel.module.css';

export interface CarouselProps {
  children: React.ReactNode;
  autoplay?: boolean;
  autoplaySpeed?: number;
  dots?: boolean;
  arrows?: boolean;
  infinite?: boolean;
  slidesToShow?: number;
  slidesToScroll?: number;
  speed?: number;
  fade?: boolean;
  pauseOnHover?: boolean;
  responsive?: Settings['responsive'];
  className?: string;
}

const Carousel: React.FC<CarouselProps> = ({
  children,
  autoplay = false,
  autoplaySpeed = 3000,
  dots = true,
  arrows = true,
  infinite = true,
  slidesToShow = 1,
  slidesToScroll = 1,
  speed = 500,
  fade = false,
  pauseOnHover = true,
  responsive,
  className = '',
}) => {
  const settings: Settings = {
    dots,
    arrows,
    infinite,
    speed,
    slidesToShow,
    slidesToScroll,
    autoplay,
    autoplaySpeed,
    fade,
    pauseOnHover,
    cssEase: 'ease-in-out',
    responsive: responsive || [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(slidesToShow, 2),
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <div className={`${styles.carouselWrapper} ${className}`}>
      <Slider {...settings}>{children}</Slider>
    </div>
  );
};

export default Carousel;